import { render, staticRenderFns } from "./role-list.vue?vue&type=template&id=585a6f00"
import script from "./role-list.ts?vue&type=script&lang=js&external"
export * from "./role-list.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports